// src/claims/ppStages.js — WHICH CLAIM STAGE CODES ARE PREVENT PLANT. One rule, every caller.
//
// CommonJS on purpose: api/_claim-estimate.js require()s it, App.jsx and the ESM claim
// modules import it (webpack handles both), and tools/_load-strategy.js requires it.
//
// ── SOURCED (2026-10-18) ─────────────────────────────────────────────────────
// RMA "History of Stage Codes 1989 Forward" (Stage Code Listing, updated 21-Feb-2025,
// rma.usda.gov/sites/default/files/2025-02/Stage%20Code%20Listing.pdf):
//   P2  Prevented Planting Option 2 (Unplanted Acres-98)
//   PF  Prevented Planting - Unplanted Acreage with 5% buyup option
//   PT  Prevented Planting - Insured Crop Planted (Unplanted Acreage with 10% buy up option)
//   PP  Prevented Planting - FCIC Reform Act of 1994
//   P   UNINSURED LOSS            <- NOT prevent plant
//
// CLAUDE.md already records that the buy-up wording on P2/PF/PT does NOT reflect what the
// grower elected — they are read as one stage, "prevent plant", and nothing more.
//
// Two dialects reach us:
//   - P21 worksheet lines (m13_loss_detail / indemnity_lines.stage_code): PF, P2 (PT never
//     observed). MEASURED 2026-10-18: BOTH carriers write BOTH codes — NAU 595 PF / 327 P2,
//     R&H 45 PF / 67 P2 — and CY2026 prevent-plant coverages are almost all P2 (104 of 106
//     paid cells), so "PF only" misses nearly the whole current year.
//   - indemnities.claim_stages (the P20X notice union): NAU's "PP", R&H's normalised "PF".
//
// ⚠ `P` WAS IN TWO OF THE OLD SETS AND IT IS RMA'S "UNINSURED LOSS". The 5 `P` lines in the
// book (NAU CY2025) are all $0 and ride on harvest claims (H/UH). Do not add it back.
// Any other code is NOT prevent plant until a source says so — a code whose meaning is not
// established is never silently added here.

const PP_LINE_STAGES = Object.freeze(["PF", "P2", "PT"]);
const PP_NOTICE_STAGES = Object.freeze(["PP"]);
const PP_STAGES = Object.freeze([...PP_LINE_STAGES, ...PP_NOTICE_STAGES]);

const norm = (s) => String(s == null ? "" : s).trim().toUpperCase();

// The codes are the same on both carriers (measured above), so no AIP argument is taken —
// a parameter accepted and ignored would read as a distinction that does not exist.
function isPreventPlantStage(code) {
  return PP_STAGES.includes(norm(code));
}

// Does a paid line's stage belong to the stage an estimate was frozen for? A prevent-plant
// estimate is ONE stage whatever tier code the carrier writes, so it matches every PP code;
// any other stage matches exactly; an estimate with no stage matches every line.
function stageMatches(estimateStage, lineStage) {
  const want = norm(estimateStage);
  if (!want) return true;
  if (isPreventPlantStage(want)) return isPreventPlantStage(lineStage);
  return norm(lineStage) === want;
}

module.exports = { PP_LINE_STAGES, PP_NOTICE_STAGES, PP_STAGES, isPreventPlantStage, stageMatches };
